import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
export var AdminProfileSchema = new SimpleSchema({
    adminRole: {
        type: String,
        label: "Fonction",
        optional: true
    },
    twitterHandle: {
        type: String,
        label: "Compte Twitter",
        optional: true
    }
});
